import _ from "underscore";
import React from "react";
import ReactDOM from "react-dom";
import {Index} from "./components/layout";
import Login from "./screens/login";
import Register from "./screens/register";
import Recover from "./screens/recover";
import Home from "./screens/home";
import RegistrationOk from "./screens/registrationOk";
import Confirm from "./screens/confirm";
import * as ui from "./utils/ui";
import * as plugins from "./pluginsimpl";
import {resumeSession} from "../actions/session";
import * as keyboard from "./utils/keyboard";
import {SessionStore} from "../stores/session";
import {EntitiesGrid, EntityForm, RevisionGrid} from "./screens/entities";
import { getUserProfileImage } from "../actions/ui";
import { setupMenu, setupTopMenu } from "../actions/menu";
import * as NotificationCenter from "../utils/notificationCenter";
import {register} from "../framework/services";
import entities from "./entities/entities";
import { isOrganizationAdmin, isSuperuser } from "../api/session";
import Settings from "./screens/settings";
import MobileHome from "./screens/mobile/home";
import CategoriesGrid from "./screens/entities/categoriesGrid";
import CategoryForm from "./screens/entities/categoryForm";
import QuestionTemlpatesGrid from "./screens/entities/questionTemplatesGrid";
import SurveyForm from "./screens/mobile/surveyForm";
import OngoingSurveys from "./screens/mobile/ongoingSurveys";
import StoresSummary from "./screens/mobile/storesSummary";
import StoreDetails from "./screens/mobile/storeDetails";
import { SurveyTemplateHeaderForm } from "./screens/entities/surveyTemplateHeaderForm";
import { SurveyTemplateQuestionsForm } from "./screens/entities/surveyTemplateQuestionsForm";
import { SurveyTemplateWeightsForm } from "./screens/entities/surveyTemplateWeightsForm";
import { StoreHeaderForm } from "./screens/entities/storeHeaderForm";
import { StoreTargetsForm } from "./screens/entities/storeTargetsForm";
import { SurveyTemplateStoresForm } from "./screens/entities/surveyTemplateStoresForm";
import { Slideshow } from "./screens/slideshow";
import { toast } from "../plugins";


export default function main() {
	/* fix for full height on mobile https://css-tricks.com/the-trick-to-viewport-units-on-mobile/ */
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
	window.addEventListener('resize', _.throttle(() => {
		// We execute the same script as before
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	  }, 100));

	/* Register plugins */
	plugins.register()
	
	/* Admin routes */
	ui.addRoute("/entities/macroarea", params => ui.changeScreen(<CategoriesGrid key={"macroarea"} entity={"category"} level={0} params={params} />))
	ui.addRoute("/entities/area", params => ui.changeScreen(<CategoriesGrid key={"area"} entity={"category"} level={1} params={params} />))
	ui.addRoute("/entities/category", params => ui.changeScreen(<CategoriesGrid key={"category"} entity={"category"} level={2} params={params} />))
	ui.addRoute("/entities/questionTemplate", params => ui.changeScreen(<QuestionTemlpatesGrid key={"questionTemlpates"} entity={"questionTemplate"} params={params} />))
	
	ui.addRoute("/entities/store/:entityId/header", params => ui.changeScreen(<StoreHeaderForm key={"store_header_form"} entity={"store"} entityId={params.entityId} params={params}/>))
	ui.addRoute("/entities/store/:entityId/targets", params => ui.changeScreen(<StoreTargetsForm key={"store_targets_form"} entity={"store"} entityId={params.entityId} params={params}/>))
	

	ui.addRoute("/entities/surveyTemplate/:entityId/header", params => ui.changeScreen(<SurveyTemplateHeaderForm key={"surveyTemplate_header_form"} entity={"surveyTemplate"} entityId={params.entityId} params={params}/>))
	ui.addRoute("/entities/surveyTemplate/:entityId/questions", params => ui.changeScreen(<SurveyTemplateQuestionsForm key={"surveyTemplate_questions_form"} entity={"surveyTemplate"} entityId={params.entityId} params={params}/>))
	ui.addRoute("/entities/surveyTemplate/:entityId/weights", params => ui.changeScreen(<SurveyTemplateWeightsForm key={"surveyTemplate_weights_form"} entity={"surveyTemplate"} entityId={params.entityId} params={params}/>))
	ui.addRoute("/entities/surveyTemplate/:entityId/stores", params => ui.changeScreen(<SurveyTemplateStoresForm key={"surveyTemplate_stores_form"} entity={"surveyTemplate"} entityId={params.entityId} params={params}/>))


	ui.addRoute("/entities/macroarea/:entityId", params => ui.changeScreen(<CategoryForm key={"macroarea_form"} entity={"category"} level={0} entityId={params.entityId} params={params}/>))
	ui.addRoute("/entities/area/:entityId", params => ui.changeScreen(<CategoryForm key={"area_form"} entity={"category"} level={1} entityId={params.entityId} params={params}/>))
	ui.addRoute("/entities/category/:entityId", params => ui.changeScreen(<CategoryForm key={"category_form"} entity={"category"} level={2} entityId={params.entityId} params={params}/>))
	
	ui.addRoute("/entities/:entity", params => ui.changeScreen(<EntitiesGrid key={params.entity} entity={params.entity} params={params}/>))
	ui.addRoute("/entities/:entity/:entityId", params => ui.changeScreen(<EntityForm key={params.entity} entity={params.entity} entityId={params.entityId} params={params}/>))
	ui.addRoute("/entities/single/:entity", params => ui.changeScreen(<EntityForm key={params.entity} entity={params.entity} entityId="_" params={params}/>))
	ui.addRoute("/revision/:entity/:entityId", params => ui.changeScreen(<RevisionGrid key={params.entity} entityId={params.entityId}  entity={params.entity} params={params} />))
	ui.addRoute("/recover", params => ui.changeScreen(<Recover />))
	ui.addRoute("/dashboard", params => ui.changeScreen(<Home {...params}/>))
	ui.addRoute("/settings", params => ui.changeScreen(<Settings {...params}/>))

	ui.addRoute("/public/slideshow", params => ui.changeScreen(<Slideshow {...params} />))


	/* Account routes */
	ui.addRoute("/login", params => ui.changeScreen(<Login />))
	//ui.addRoute("/register", params => ui.changeScreen(<Register />))
	//ui.addRoute("/recover", params => ui.changeScreen(<Recover />))
	//ui.addRoute("/registrationComplete", params => ui.changeScreen(<RegistrationOk />))

	ui.addRoute("/confirm", params => ui.changeScreen(<Confirm activationCode={params.activationCode}/>))

	/* home route */
	ui.addRoute("/", params => ui.changeScreen(<MobileHome />))

	/* Mobile routes */
	ui.addRoute("/app", params => ui.changeScreen(<MobileHome {...params}/>))
	ui.addRoute("/app/surveys/ongoing", params => ui.changeScreen(<OngoingSurveys {...params}/>))
	ui.addRoute("/app/survey/:surveyId", params => ui.changeScreen(<SurveyForm {...params}/>))
	ui.addRoute("/app/stores", params => ui.changeScreen(<StoresSummary {...params}/>))
	ui.addRoute("/app/store/:storeId", params => ui.changeScreen(<StoreDetails {...params}/>))

	/* Attach keyboard for global key bindings */
	keyboard.attach()

	/* render main index page into dom */
	ReactDOM.render(<Index />, document.getElementById("entry-point"))

	/** session actions catching */
	NotificationCenter.addObserver("login", (user) => {
		/*if (!user.needToChangePassword) {
			getUserProfileImage();
			setupMenu({user});
		}*/
		setupMenu({user});
	})

	NotificationCenter.addObserver("entity:saved", (data) => {
		if (data.entity == "trendConfiguration" || data.entity == "presentationConfiguration") {
			toast("Il risultato sarà disponibile tra pochi minuti");
			ui.navigate("/entities/" + data.entity);
		}
	})

	/* Avoid going in screens that require login before trying session resume */
	let owner = {}
	SessionStore.subscribe(owner, state => {
	    if (state.resumeComplete) {
	        SessionStore.unsubscribe(owner)
	        ui.startNavigation()
	    }
	})

	/* automatic login, if possible */
	resumeSession()
		.catch((e) => {
			console.log("Failed to resume session")
		})
}

register("entity", (entity)=> {
	return entities[entity]
})

register("entities", ()=> {
	return entities
})